import {
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Fade,
  Slide,
  StepContent
} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Stepper from '@material-ui/core/Stepper';
import Typography from '@material-ui/core/Typography';
import { alpha, useTheme } from '@material-ui/core/styles';
import withStyles from '@material-ui/core/styles/withStyles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import SendIcon from '@material-ui/icons/Send';
import UndoIcon from '@material-ui/icons/Undo';
import { Form, Formik } from 'formik';
import { withSnackbar } from 'notistack';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import NavigationButtons from '../../../NavigationButtons';
import TermsAndConditionsPopup from '../../../components/TermsAndConditionsPopup';
import { usePageTitle } from '../../../context/LayoutContext';
import ExportadorService from '../../../services/ExportadorService';
import axios from '../../../utils/axios';
import { ejemplo, mainDefault } from '../../../utils/data-utils';
import { Yup } from '../../../utils/form-utils';
import EntregaForm from './EntregaForm';
import ExportadorForm from './ExportadorForm';
import FacturasForm from './FacturasForm';
import FormikSubmitEffect from './FormikSubmitEffect';
import ImportadorForm from './ImportadorForm';
import MercaderiasForm from './MercaderiasForm';

const styles = theme => ({
  img: {
    width: '150px',
    [theme.breakpoints.down('sm')]: {
      width: '100px'
    }
  },
  container: {
    marginLeft: 0,
    marginRight: 0,
    paddingBottom: theme.spacing(8),
    [theme.breakpoints.down('sm')]: {
      paddingBottom: 0,
      padding: 0
    }
  },
  innerContainer: {
    [theme.breakpoints.down('sm')]: {
      padding: 0
    }
  },
  paper: {
    // marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    padding: theme.spacing(4),
    // marginLeft: theme.spacing(6),
    // marginRight: theme.spacing(6),
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      marginBottom: theme.spacing(5),
      padding: theme.spacing(1.5),
      paddingTop: theme.spacing(2)
    }
  },
  stepper: {
    [theme.breakpoints.up('md')]: {
      borderRadius: theme.spacing(0.5),
      background: alpha(theme.palette.primary.main, 0.05)
    },
    [theme.breakpoints.down('sm')]: {
      paddingTop: 0,
      paddingLeft: 0,
      paddingRight: 0
    }
  },
  stepLabel: {
    paddingTop: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      padding: 0
    }
  },
  stepContainer: {
    padding: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      padding: 0
    }
  },
  inputGroup: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      display: 'inline'
    }
  },
  sidebarAboutBox: {
    // marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    // marginLeft: theme.spacing(6),
    background: '#fff',
    padding: '20px',
    borderRadius: '8px',
    boxShadow: '0.5rem 0.5rem 2rem 0 rgba(0, 0, 0, 0.2)'
  },
  menuButton: {
    marginRight: theme.spacing(2)
  },
  title: {
    flexGrow: 1
  },
  extendedIcon: {
    marginRight: theme.spacing(1)
  },
  datosPrueba: {
    paddingBottom: theme.spacing(2)
  }
});

// custom hook for getting previous value
function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

const Pasos = ({
  activeStep,
  isPhone,
  classes,
  steps,
  loadingSendPre,
  ...props
}) => {
  const prevCount = usePrevious(activeStep);

  const [config, setConfig] = useState({
    content: steps[activeStep],
    slideIn: true,
    slideDirection: 'up'
  });

  const onArrowClick = useCallback(
    async (prev, active) => {
      if (prev !== undefined) {
        const direction = prev > active ? 'left' : 'right';
        const oppDirection = prev > active ? 'right' : 'left';

        if (active === 0 && prev === 0) {
          return;
        }

        if (active === prev) {
          return;
        }
        setConfig({
          content: steps[prev],
          slideIn: false,
          slideDirection: direction
        });
        setTimeout(() => {
          setConfig({
            content: steps[active],
            slideIn: true,
            slideDirection: oppDirection
          });
        }, 500);
      }
    },
    [steps]
  );

  useEffect(
    () => {
      onArrowClick(prevCount, activeStep);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [activeStep, onArrowClick]
  );

  return (
    <>
      <Stepper
        // elevation={isPhone ? false : 2}
        activeStep={activeStep}
        // alternativeLabel={!isPhone}
        orientation={isPhone ? 'vertical' : 'horizontal'}
        className={classes.stepper}
      >
        {steps.map(({ label }, index) => (
          <Step key={label}>
            <StepLabel>
              {activeStep === index ? (
                <Typography variant="h6">{label}</Typography>
              ) : (
                label
              )}
            </StepLabel>
            {isPhone && (
              <StepContent>
                <Container maxWidth="md" className={classes.innerContainer}>
                  <div className={classes.stepContainer}>
                    {steps[index].content}
                  </div>
                </Container>
              </StepContent>
            )}
          </Step>
        ))}
      </Stepper>
      {!isPhone && (
        <>
          <Container maxWidth="lg" className={classes.innerContainer}>
            <div style={{ position: 'relative', overflow: 'hidden' }}>
              <Slide in={config.slideIn} direction={config.slideDirection}>
                <div className={classes.stepContainer}>
                  <Grid container item justifyContent="center">
                    <Typography variant="h6" gutterBottom>
                      {config.content.label}
                    </Typography>
                  </Grid>
                  <div>{config.content.content}</div>
                </div>
              </Slide>
            </div>
          </Container>
        </>
      )}
      <Divider />
      <br />
      <NavigationButtons
        {...{ activeStep, isPhone, steps, classes, loadingSendPre, ...props }}
      />
      <br />
    </>
  );
};

const scrollToRef = ref => {
  if (ref && ref.current) {
    ref.current.scrollIntoView({
      behavior: 'smooth'
    });
  }
};

const validEmailAddress = 'validation.validEmailAddress';
const validationSchema = [
  Yup.object().shape({
    rucExportador: Yup.string().required(),
    razonSocialExportador: Yup.string().required(),
    ciudadExportador: Yup.string().required(),
    direccionExpo: Yup.string().required(),
    codigoPostal: Yup.string().required(),
    personaContacto: Yup.string().required(),
    telefono: Yup.string().required(),
    emailExpo: Yup.string()
      .email(validEmailAddress)
      .required()
  }),
  Yup.object().shape({
    importador: Yup.object().shape({
      id: Yup.string().required()
    })
  }),
  Yup.object().shape({
    facturas: Yup.array(Yup.object().shape({})).required(
      'Debe cargar las facturas'
    )
  }),
  Yup.object().shape({
    moneda: Yup.object().shape({
      codigo: Yup.string().required()
    }),
    mercaderias: Yup.array()
      .of(
        Yup.object().shape({
          factura: Yup.object().shape({
            id: Yup.string().required('La factura es requerida')
          })
        })
      )
      .required('Debe cargar las mercaderías')
  }),
  Yup.object().shape({
    persona: Yup.object().shape({
      id: Yup.string().required()
    }),
    instruccion: Yup.object().shape({
      id: Yup.string().required()
    })
  })
];

const Formulario = props => {
  const history = useHistory();
  const { setPageTitle } = usePageTitle();
  const myRef = useRef(null);
  const scrollTop = () => setTimeout(() => scrollToRef(myRef));
  const { classes, enqueueSnackbar } = props;
  const [isDirty, setIsDirty] = useState(false);
  const [baseObject, setBaseObject] = useState({ ...mainDefault });
  const [empresa, setEmpresa] = useState();
  const [activeStep, setActiveStep] = useState(0);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openPerfil, setOpenPerfil] = useState(false);
  const [enviado] = useState(false);
  const [loadingEdit] = useState(false);
  const [loadingSendPre, setLoadingSendPre] = useState(false);
  const [formPrepared] = useState(true);
  const [showTerms, setShowTerms] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [termsAccepted, setTermsAccepted] = useState(false);
  const { t } = useTranslation();

  const forms = {
    INICIAL: 'INICIAL',
    PASOS: 'PASOS',
    FINAL: 'FINAL'
  };

  const [activeForm, setActiveForm] = useState(forms.PASOS);
  const theme = useTheme();
  const isPhone = useMediaQuery(theme.breakpoints.down('sm'));
  const formik = useRef();
  const gridProps = {
    spacing: isPhone ? 2 : 3,
    className: classes.inputGroup
  };

  const stepProps = {
    ...props,
    gridProps
  };

  const steps = [
    {
      label: 'Exportador',
      content: <ExportadorForm {...stepProps} />
    },
    {
      label: 'Importador',
      content: <ImportadorForm {...stepProps} />
    },
    {
      label: 'Facturas',
      content: <FacturasForm {...stepProps} />
    },
    {
      label: 'Mercaderías',
      content: <MercaderiasForm {...stepProps} />
    },
    {
      label: 'Entrega',
      content: <EntregaForm {...stepProps} />
    }
  ];

  const onSubmitError = values => {
    console.log('values', values);
    enqueueSnackbar('Verificar formatos y campos obligatorios', {
      variant: 'warning'
    });
  };

  const handleNext = () => {
    setActiveStep(prevActiveStep => prevActiveStep + 1);
  };

  const handleBack = () => {
    if (activeStep === 0) {
      setActiveForm(forms.INICIAL);
    } else {
      setActiveStep(prevActiveStep => prevActiveStep - 1);
    }
  };

  const enviar = async () => {
    const { values } = formik.current;
    console.log('onSubmit', values);
    setIsDirty(true);
    setLoadingSendPre(true);
    try {
      // setTouched({}, false);
      const valuesToSend = Object.assign({}, values);
      valuesToSend.idPersona = valuesToSend.persona.id;
      valuesToSend.idImportador = valuesToSend.importador.id;
      valuesToSend.moneda = valuesToSend.moneda.codigo;
      valuesToSend.instruccion = valuesToSend.instruccion.id;
      valuesToSend.mercaderias = valuesToSend.mercaderias.map(
        (item, index) => ({
          ...item,
          partidaArancelaria: {
            id: item.partidaArancelaria.id,
            codigo: item.partidaArancelaria.codigo
          },
          nroCertificadoOrigen: item.factura.nroFactura,
          fechaCertificadoOrigen: item.factura.fechaFactura.format(
            'YYYY-MM-DD'
          ),
          index
        })
      );

      valuesToSend.facturas = valuesToSend.facturas.map(item => ({
        ...item,
        montoFactura: item.montoFactura,
        fechaFactura: item.fechaFactura.format('DD/MM/YYYY')
      }));

      const data = new FormData();
      data.append('dto', JSON.stringify(valuesToSend));
      if (values.facturas) {
        for (const factura of values.facturas) {
          data.append(
            'facturas',
            new File(
              [factura.factura[0]],
              encodeURIComponent(factura.factura[0].name),
              {
                type: factura.factura[0].type,
                lastModified: factura.factura[0].lastModified
              }
            )
          );
        }
      }
      try {
        await axios.post('vue/formulario', data, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        enqueueSnackbar('Enviado correctamente', { variant: 'success' });
        history.push('/formularios');
      } catch (err) {
        console.log(err);
        if (err?.response?.data) {
          let messageString = '';
          const messages = Object.values(err.response.data);
          if (messages?.length > 0) {
            messageString = messages.flat().join('\n');
          }
          enqueueSnackbar(messageString, {
            variant: 'error',
            autoHideDuration: 10000
          });
        } else {
          enqueueSnackbar('Error al intentar enviar', { variant: 'error' });
        }
      }

      scrollTop();
      setLoadingSendPre(false);
    } catch (error) {
      console.log(error);
      setLoadingSendPre(false);
    }
  };

  const onSubmit = () => {
    if (activeStep < 4) {
      handleNext();
    } else {
      setShowTerms(true);
    }
    formik.current.setSubmitting(false);
  };

  const handleClose = () => {
    setOpenConfirm(false);
  };

  const handleOk = () => {
    setOpenConfirm(false);
    enviar();
  };

  const handleClosePerfil = () => {
    setOpenPerfil(false);
  };

  const handleOkPerfil = () => {
    setOpenPerfil(false);
    history.push('/perfil');
  };

  const handleEnviarClick = () => {
    // Mostrar el popup de términos cada vez que se intenta enviar
    setShowTerms(true);
  };

  const handleAcceptTerms = () => {
    setTermsAccepted(true);
    setShowTerms(false);
    // Ejecutar el envío después de aceptar términos
    enviar();
  };

  const handleDatosPrueba = () => {
    setBaseObject(prev => ({ ...prev, ...ejemplo }));
    enqueueSnackbar('Se han cargado correctamente los datos de prueba', {
      variant: 'success'
    });
  };

  const actualizarDatosExportador = exportador => {
    setBaseObject(prev => ({
      ...prev,
      razonSocialExportador: exportador.razonSocial,
      rucExportador: exportador.ruc,
      direccionExpo: exportador.direccion,
      ciudadExportador: exportador.ciudad,
      codigoPostal: exportador.codigoPostal || '',
      personaContacto: exportador.personaContacto || '',
      telefono: exportador.telefono || '',
      emailExpo: exportador.email || ''
    }));
  };

  useEffect(
    () => {
      const eventListener = event => {
        if (isDirty) {
          // Cancel the event as stated by the standard.
          event.preventDefault();
          // Chrome requires returnValue to be set.
          // eslint-disable-next-line no-param-reassign
          event.returnValue =
            'Es posible que los cambios que implementaste no se puedan guardar';
        }
      };
      window.addEventListener('beforeunload', eventListener);
      return function cleanup() {
        window.removeEventListener('beforeunload', eventListener);
      };
    },
    [activeStep, isDirty]
  );

  useEffect(() => {
    const loadExportador = async () => {
      try {
        const response = await ExportadorService.getPerfil();
        if (response && response.data) {
          setEmpresa(response.data);
          actualizarDatosExportador(response.data);

          // Si no se tienen todos los datos es porque aún no se configuró el perfil
          if (
            !(
              response.data.razonSocial &&
              response.data.ruc &&
              response.data.direccion &&
              response.data.ciudad &&
              response.data.codigoPostal &&
              response.data.personaContacto &&
              response.data.telefono &&
              response.data.email
            )
          ) {
            setOpenPerfil(true);
          }
        }
      } catch (error) {
        console.log(error);
      }
    };
    loadExportador();
  }, []);

  useEffect(
    () => {
      setPageTitle('Generar formulario');
    },
    [setPageTitle]
  );

  return (
    <div>
      <div className={classes.container}>
        <Paper className={classes.paper} elevation={8}>
          <div ref={myRef} style={{ height: 16 }} />
          <div style={{ width: '100%', textAlign: 'center' }}>
            <Fade
              in={loadingEdit}
              style={{
                transitionDelay: loadingEdit ? '800ms' : '0ms'
              }}
              unmountOnExit
            >
              <CircularProgress />
            </Fade>
          </div>
          {process.env.REACT_APP_PROFILE !== 'prod' &&
            empresa && (
              <Grid
                container
                alignItems="center"
                justifyContent="center"
                spacing={1}
                className={classes.datosPrueba}
              >
                <Grid item>
                  <Button
                    onClick={handleDatosPrueba}
                    variant="contained"
                    color="primary"
                    size={isPhone ? 'small' : 'medium'}
                  >
                    Usar datos de prueba
                  </Button>
                </Grid>
              </Grid>
            )}

          {formPrepared && (
            <>
              <TermsAndConditionsPopup
                open={showTerms}
                onAccept={handleAcceptTerms}
                onCancel={() => setShowTerms(false)}
              />
              <Dialog
                open={openPerfil}
                onClose={handleClosePerfil}
                aria-labelledby="dialog-title"
              >
                <DialogTitle id="dialog-title">Perfil incompleto</DialogTitle>
                <DialogContent>
                  <DialogContentText>
                    Debe cargar todos los datos de su empresa para poder cargar
                    formularios
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleClosePerfil}>
                    {t('general.cancel')}
                  </Button>
                  <Button
                    onClick={handleOkPerfil}
                    color="primary"
                    variant="contained"
                  >
                    OK
                  </Button>
                </DialogActions>
              </Dialog>
              <Dialog
                open={openConfirm}
                onClose={handleClose}
                aria-labelledby="dialog-title"
              >
                <DialogTitle id="dialog-title">
                  {t('general.confirmTitle')}
                </DialogTitle>
                <DialogContent>
                  <DialogContentText>
                    {t('general.confirmDescription')}
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleClose}>{t('general.cancel')}</Button>
                  <Button
                    onClick={handleOk}
                    color="primary"
                    variant="contained"
                  >
                    {t('general.send')}
                  </Button>
                </DialogActions>
              </Dialog>
              <Formik
                enableReinitialize
                initialValues={baseObject}
                validationSchema={validationSchema[activeStep]}
                innerRef={formik}
                onSubmit={onSubmit}
              >
                {() => (
                  <>
                    <FormikSubmitEffect
                      onSubmitError={onSubmitError}
                      validationSchema={validationSchema[activeStep]}
                    />
                    <Form noValidate>
                      {activeForm === forms.INICIAL && (
                        <Divider light variant="middle" />
                      )}
                      <Collapse
                        in={activeForm === forms.INICIAL}
                        mountOnEnter
                        unmountOnExit
                      >
                        <div>Form Inicial</div>
                      </Collapse>
                      <Collapse
                        in={activeForm === forms.PASOS}
                        mountOnEnter
                        unmountOnExit
                      >
                        <div>
                          <Pasos
                            {...{
                              activeStep,
                              isPhone,
                              classes,
                              loadingSendPre,
                              steps,
                              handleBack,
                              handleNext
                            }}
                          />
                        </div>
                      </Collapse>
                    </Form>
                  </>
                )}
              </Formik>
            </>
          )}

          <Collapse in={activeForm === forms.FINAL} mountOnEnter unmountOnExit>
            <Container style={{ paddingTop: 30 }}>
              {formik.current && <div>Más datos</div>}
              {!enviado && (
                <Grid
                  container
                  alignItems="center"
                  justifyContent="center"
                  spacing={1}
                >
                  <Grid item>
                    <Button
                      onClick={() => setActiveForm(forms.PASOS)}
                      className={classes.backButton}
                      size={isPhone ? 'small' : 'medium'}
                      startIcon={<UndoIcon />}
                    >
                      Volver
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      onClick={handleEnviarClick}
                      className={classes.backButton}
                      size={isPhone ? 'small' : 'medium'}
                      variant="contained"
                      color="primary"
                      endIcon={<SendIcon />}
                    >
                      Enviar
                    </Button>
                  </Grid>
                </Grid>
              )}
            </Container>
          </Collapse>
        </Paper>
      </div>
    </div>
  );
};

Formulario.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withSnackbar(withStyles(styles)(Formulario));
